import { Request } from "@/utils";
import config from "@/configs";

export async function subuserListAuth(params) {
  return Request.get(config.subuserListAuth, { params });
}

export async function defaultSubuserAuth() {
  return Request.get(config.defaultSubuserAuth);
}
